import * as React from "react";
import { Snackbar as MUISnackbar, useTheme } from "@mui/material";
import styled from "styled-components";
import MuiAlert from "@mui/lab/Alert";

const StyledMUISnackbar = styled(MUISnackbar)`
  .MuiAlert-root {
    border-radius: 8px !important;
    box-shadow:
      0px 3px 5px -1px rgba(60, 71, 95, 0.2),
      0px 5px 8px rgba(60, 71, 95, 0.14),
      0px 1px 14px rgba(60, 71, 95, 0.12) !important;
    min-width: 320px;
  }

  button:focus {
    outline: none;
  }

  .MuiIconButton-root:hover {
    background: unset;
  }

  .MuiIconButton-sizeSmall {
    min-width: 30px;
  }
`;

export const SnackbarAlert = ({
  open = false,
  severity = "info",
  message = "",
  onClose,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  color = "secondary",
  autoHideDuration = 10000,
}) => {
  return (
    <StyledMUISnackbar
      {...{
        open,
        message,
        anchorOrigin,
        color,
        autoHideDuration,
        onClose,
      }}
    >
      <MuiAlert {...{ onClose, severity }} sx={{ boxShadow: "lg" }}>
        {message}
      </MuiAlert>
    </StyledMUISnackbar>
  );
};
